import React from "react";
import { Helmet } from 'react-helmet';

const ThoughtPaperThankYouLanding = () => {
    return (
        <section>
            <Helmet>
                <title>Evaluationz: Thought Paper Thank You</title>
                <meta name="description" content="Read our blogs on the latest news and thoughts surrounding verification, Thought Paper Thank You" />
                <meta name="keywords" content="address verification, criminal verification, drug panel testing, employment verification, education verification, employee verification, user verification, vendor verification, Identity check, Social Media Check, Reference check, Drug test, Digital verification, passport verification, credit check, API Integration, Reduced TAT, Real time verification, verification Specialist, NASCOM empanelled, credit score check, Evaluationz, Evaluationz India Pvt. Ltd., Verification India, AI, Artificial Intelligence, BlueG, Coporate verification, IT Verification, Ites Verification, Banking and Financial Services Industry Verification, Automative verification, eCommerce verification, healthcare verification, rental verificaion, matrimonial verification, hyperlocal verification, blue collar verification, white collar verification, Thought Paper Thank You" />
                <meta property="og:description" content="Read our blogs on the latest news and thoughts surrounding verification, Thought Paper Thank You" />
                <meta property="og:url" content="https://evaluationz.com/blog" />
                <meta property="og:image" content="https://evaluationz.com/images/favicon.jpg" />
                <meta property="og:image:secure_url" content="https://evaluationz.com/images/favicon.jpg" />
                <meta name="twitter:image" content="https://evaluationz.com/images/favicon.jpg" />
            </Helmet>

            <div className="hero-block pt-4 pb-5">
                <div className="container pt-5">
                    <div className="col-12 px-0">
                        <h1>Thought Paper</h1>
                    </div>
                    <div className="row d-flex justify-content-between">
                        <div className="col-md-6 py-2">
                            <div className="user-card h-100 blog-card bg-white">
                                <div className="about-section-item about-item-image text-center blue-image-left content-view">
                                    <img src="images/services/interview-impersonation/white-paper-img.png"
                                         alt="interview-impersonation"/>
                                </div>

                                <div className="card-body text-center">
                                    <h4 className="mb-4">Unmasking Interview Impersonation: Securing Hiring</h4>
                                    <a href="pdf/thought-paper/thought-paper-1.pdf"
                                       target="_blank"
                                       download
                                       className="btn btn-primary btn-red shadow-sm">Download</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ThoughtPaperThankYouLanding;
